module.exports = __webpack_public_path__ + "static/img/zz-barnner.23fbac36.jpg";